<template>
    <v-container class="fill-height" fluid>
        <v-row class="py-5 py-0" justify="center">
            <v-col class="rounded-lg  elevation-5 pa-0 " cols="auto">
                <v-card class="authentication">
                    <v-card-title class="text-h5 primary secondary--text">
                        {{ title }}
                    </v-card-title>
                    <div class="d-flex justify-center mt-8">
                        <v-img :src="require('@/assets/logo.png')" contain max-width="50%"/>
                    </div>
                    <v-card-text class="pa-7">
                        <slot/>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
  name: "AuthenticationBasic",
  props: {
    title: {
      type: String,
      required: true,
    }
  }
};
</script>

<style lang="scss" scoped>
@import "authentication-basic";
</style>